/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Performancereport_Finalraise3Inputs */

const en_coinvestments_performancereport_finalraise3 = /** @type {(inputs: Coinvestments_Performancereport_Finalraise3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Final raise`)
};

/**
* | output |
* | --- |
* | "Final raise" |
*
* @param {Coinvestments_Performancereport_Finalraise3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_performancereport_finalraise3 = /** @type {((inputs?: Coinvestments_Performancereport_Finalraise3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Performancereport_Finalraise3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_performancereport_finalraise3(inputs)
});
export { coinvestments_performancereport_finalraise3 as "coInvestments_performanceReport_finalRaise" }